<template>
  <gg-card height="100%">
    <gg-card-header>
      Payment Method
      <gg-btn @click="dialog = true"  color="primary" class="float-right">
        Update
        <span class="visually-hidden text-lowercase">
          payment method button
        </span>
      </gg-btn>

      <edit-payment-form
        :dialog="dialog"
        closable
        @close="dialog = false"
      />
    </gg-card-header>
    <gg-card-text class="pa-4">
      <v-row v-if="SessionProfile.card_type">
        <v-col class="text-right" md="3">
          <v-img
            :src="`/static/img/cards/${cardImage}`"
            width="150"
          />
        </v-col>
        <v-col class="text-left" md="9">
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>
                {{ SessionProfile.card_type }} **** {{ SessionProfile.card_lastfour }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-subtitle>Expires {{ SessionProfile.card_expdate }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-col>
      </v-row>
      <div class="d-flex flex-column justify-center align-items-center" v-else>
        <v-icon size="100">
          mdi-credit-card
        </v-icon>
        <span class="body-1">No credit card available</span>
      </div>
    </gg-card-text>
  </gg-card>
</template>

<script>
import { mapGetters } from 'vuex'
import EditPaymentForm from '@/components/Profile/EditPaymentForm'

export default {
  name: 'PaymentCard',
  components: {
    EditPaymentForm,
  },
  data () {
    return {
      dialog: false,
    }
  },
  computed: {
    ...mapGetters(['SessionProfile']),
    cardImage () {
      switch (this.SessionProfile.card_type.toLowerCase()) {
        case 'visa':
          return 'visa.png'
        case 'american express':
          return 'amex-dark.png'
        case 'mastercard':
          return 'mastercard.png'
        case 'discover':
          return 'discover.png'
        default:
          return 'visa.png'
      }
    }
  },
}
</script>
